import jsPDF from "jspdf";
import "jspdf-autotable";
import { numberWithCommas } from "../helpers/app/numberFormater";
import image from "../../assets/logo/authLogo.png";
import { centrePdfText } from "../helpers/app/pdf";
import dayjs from "dayjs";

const generateCashbookPdf = (data, startDate, endDate, options = {}) => {
  const { projectName, tabLabel = "ALL TRANSACTIONS" } = options;

  const doc = new jsPDF({ orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(10);
  doc.addImage(image, "PNG", (pageWidth - 80) / 2, 15, 80, 25);
  centrePdfText(
    doc,
    "P.O.BOX 610029, Maracha, Uganda | Adongoro Cell, Maracha Town Council",
    45
  );
  centrePdfText(doc, "Mob: +256 393102379", 60);
  centrePdfText(
    doc,
    "Web: www.amaniinitiative.org | Email: info.amaniinitiative@gmail.com",
    65
  );
  centrePdfText(
    doc,
    `AMANI INITIATIVE ${projectName ? "PROJECT " : ""}CASHBOOK`,
    75
  );

  let headerY = 85;
  if (projectName) {
    centrePdfText(doc, `Project: ${projectName}`, headerY);
    headerY += 6;
  }
  centrePdfText(
    doc,
    `Period: ${dayjs(startDate).format("DD MMMM YYYY")} to ${dayjs(endDate).format("DD MMMM YYYY")} (${tabLabel})`,
    headerY
  );

  const rows = data || [];

  const pdfColumns = [
    "Date",
    "Details",
    "Category",
    "Account",
    "Project",
    "PV/IR-No",
    "Inflow (UGX)",
    "Outflow (UGX)",
    "Balance (UGX)",
  ];

  let totalInflow = 0;
  let totalOutflow = 0;
  let closingBalance = 0;

  const pdfRows = rows.map((item) => {
    totalInflow += item.income || 0;
    totalOutflow += item.expense || 0;
    closingBalance = item.balance ?? closingBalance;

    return [
      item.date ? dayjs(item.date).format("DD-MM-YYYY") : "",
      item.details || "",
      item.category || "",
      item.account || "",
      item.project || "",
      item.receiptId || "",
      item.income ? numberWithCommas(item.income) : "--",
      item.expense ? numberWithCommas(item.expense) : "--",
      item.balance !== undefined && item.balance !== null
        ? numberWithCommas(item.balance)
        : "--",
    ];
  });

  pdfRows.push([
    "",
    "",
    "",
    "",
    "",
    "TOTAL",
    numberWithCommas(totalInflow),
    numberWithCommas(totalOutflow),
    numberWithCommas(closingBalance),
  ]);

  doc.autoTable(pdfColumns, pdfRows, { startY: headerY + 10 });

  const fileNameParts = [
    "CASHBOOK",
    projectName ? projectName.replace(/\s+/g, "_").toUpperCase() : null,
    dayjs(startDate).format("YYYY-MM-DD"),
    "TO",
    dayjs(endDate).format("YYYY-MM-DD"),
  ].filter(Boolean);

  doc.save(`${fileNameParts.join("_")}.pdf`);
};

export default generateCashbookPdf;
